module.exports = __webpack_public_path__ + "img/background_blur2.ed94f60d.png";